import { Dispatch } from 'redux';
import { createAction } from '@af-common/Common/_actions/Action';
import { createAjaxAction } from '@af-common/Common/_actions/AjaxAction';
import { Toast } from '@af-common/UIData/_actions/UIDataActions';
import { SetPaginationData } from '@af-common/UserData/_actions/UserDataActions';

export enum SidebarActionType {
	NewDocument			= 'NEW_DOCUMENT',
	NewPattern			= 'NEW_PATTERN',
	OnSaveSuccess		= 'ON_SAVE_SUCCESS',
	OnSaveError			= 'ON_SAVE_ERROR',
}

export const NewDocument = () => createAction(SidebarActionType.NewDocument);
export const NewPattern = () => createAction(SidebarActionType.NewPattern);

export const OnSaveSuccess = (id:string) => createAction(SidebarActionType.OnSaveSuccess, {
	id: id
});

export const OnSaveError = () => createAction(SidebarActionType.OnSaveError);

let onSaveFailure = (dispatch:Dispatch, message:string) => {
	dispatch(Toast(message));
	dispatch(OnSaveError());
}

export const OnSave = (data: FormData) => createAjaxAction({
	url: "ajax/create/save-pattern",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.pattern) {
			dispatch(SetPaginationData({ items: [response.data.pattern], dataType: "patterns", totalItems: 1 }));
			dispatch(OnSaveSuccess(response.data.pattern.id));
		} else {
			onSaveFailure(dispatch, "An error occurred");
		}
	},
	onFailure: (response, dispatch) => {
		onSaveFailure(dispatch, response.data && response.data.reason ? response.data.reason : "Could not save your design");
	}
});

export type SidebarAction = 
	ReturnType<typeof NewDocument>			|
	ReturnType<typeof OnSaveSuccess>		|
	ReturnType<typeof OnSaveError>			|
	ReturnType<typeof OnSave>				|
	ReturnType<typeof NewPattern>